import { createFileRoute, Link } from "@tanstack/react-router";
import { Plus } from "lucide-react";
import { Header } from "@/components/universal/header";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardAction,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { RecallsTable } from "./-recalls-table";

export const Route = createFileRoute("/_private/_inventory-360/recall/lookup/")(
  {
    component: RecallLookup,
  },
);

function RecallLookup() {
  return (
    <div>
      <title>Recalls - Legrande Health Portal</title>
      <Header crumbs={[{ name: "Recalls", link: { to: "/recall/lookup" } }]} />
      <Card>
        <CardHeader>
          <CardTitle>Recalls</CardTitle>
          <CardDescription>
            Manage drug recalls across inventory lots.
          </CardDescription>
          <CardAction>
            <Button asChild>
              <Link to="/recall/create">
                <Plus />
                Create Recall
              </Link>
            </Button>
          </CardAction>
        </CardHeader>
        <CardContent>
          <RecallsTable />
        </CardContent>
      </Card>
    </div>
  );
}
